export const CONVERSATION_ASSIGNEE_NOT_DEFINED_STR = 'unidentified';

export const DEFAULT_VIEW_CHUNK_LIMIT = 10;

export const CUSTOM_VIEW_GROUPS = {
  Client: 'Client',
  Conversation: 'Conversation',
  Partner: 'Partner',
  Site: 'Site',
  Project: 'Project',
};

export const OPTIMISTIC_ID_PREFIX = 'temp-id';
